<mat-sidenav position="end" mode="over" [opened]="visible" class="notification-center-wrapper" [disableClose]="true">
	<h1>
		<span>{{ 'notificationcenter.heading' | translate }}</span>
		@if (notificationService.getNotificationCount()) {
			<a (click)="notificationService.resetAll()" class="clear-all">
				{{ 'notificationcenter.clearall' | translate }}
			</a>
		}
		<a (click)="notificationService.toggleNotificationCenter()" class="clear-all">
			{{ 'notificationcenter.close' | translate }}
		</a>
	</h1>
	@for (item of notificationService.allMessages$ | async; track item; let i = $index) {
		<app-notificationitem [item]="item" [index]="i"></app-notificationitem>
	}
	@if (!(notificationService.allMessages$ | async).length) {
		<div>{{ 'notificationcenter.empty' | translate }}</div>
	}
</mat-sidenav>
